import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { RefreshCw } from 'lucide-react';

interface UpdateToastProps {
  registration: ServiceWorkerRegistration | null;
}

const UpdateToast: React.FC<UpdateToastProps> = ({ registration }) => {
  const reload = () => {
    // Tell the waiting worker to take over, then reload once it does.
    registration?.waiting?.postMessage({ type: 'SKIP_WAITING' });
    navigator.serviceWorker?.addEventListener('controllerchange', () => window.location.reload(), {
      once: true,
    });
  };

  return (
    <AnimatePresence>
      {registration && (
        <motion.div
          initial={{ opacity: 0, y: -16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -16 }}
          role="status"
          className="fixed inset-x-0 top-[calc(env(safe-area-inset-top)+0.75rem)] z-50 px-3"
        >
          <div className="mx-auto flex max-w-md items-center gap-3 rounded-xl bg-surface p-3 shadow-lg ring-1 ring-line">
            <span className="flex-1 text-sm text-content">A new version is available.</span>
            <button
              type="button"
              onClick={reload}
              className="inline-flex min-h-11 items-center gap-2 rounded-lg bg-inverse px-3 text-sm font-medium text-inverse-content transition hover:opacity-90"
            >
              <RefreshCw size={16} aria-hidden />
              Refresh
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default UpdateToast;
